import { noop } from "lodash";
import { paywallPriceTypes } from "@circle-react/types/PaywallPrice";
import type {
  PreviewComponentByVariantsProps,
  PreviewComponents,
} from "../../../types";
import { Lines } from "../Lines";
import { installmentsVariants } from "./installments";
import { onetimeVariants } from "./onetime";
import { subscriptionVariants } from "./subscription";

const defaultVariant: PreviewComponents = [
  [Lines.TodayPaymentLine, noop],
  [Lines.SubtotalLine, noop],
  [Lines.DiscountLine, noop],
  [Lines.TaxLine, noop],
  [Lines.EndingBalanceLine, noop],
];

export const componentsByVariants: PreviewComponentByVariantsProps<{
  onetime: PreviewComponents;
  subscription: PreviewComponents;
  installments: PreviewComponents;
}> = {
  default: {
    [paywallPriceTypes.onetime]: defaultVariant,
    [paywallPriceTypes.subscription]: defaultVariant,
    [paywallPriceTypes.installments]: defaultVariant,
  },
  paywall_customization: {
    [paywallPriceTypes.onetime]: onetimeVariants,
    [paywallPriceTypes.subscription]: subscriptionVariants,
    [paywallPriceTypes.installments]: installmentsVariants,
  },
};
